package com.islamicmedia.site.components

import androidx.compose.runtime.Composable
import com.islamicmedia.shared.domain.model.QuranReference
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun QuranReferenceBox(
    reference: QuranReference
) {
    Div(attrs = {
        style {
            paddingTop(14.px)
            property("border-top", "1px solid rgba(0, 0, 0, 0.06)")
            marginTop(14.px)
        }
    }) {
        Div(attrs = {
            style {
                fontWeight(700)
                fontSize(14.px)
                color(QuranTextDark)
                marginBottom(12.px)
            }
        }) { Text("Quranic Reference") }

        // Centered, mushaf-style spacing. The Arabic + ayah-end medallions (۝ + verse
        // number) come pre-built from the server's authoritative Uthmani text; the
        // 'Digital Khatt' webfont renders the medallion.
        P(attrs = {
            style {
                property("direction", "rtl")
                property("text-align", "right")
                property("font-family", "'Digital Khatt', 'Traditional Arabic', 'Scheherazade', serif")
                fontSize(26.px)
                lineHeight(50.px)
                color(Gray900)
                margin(0.px, 0.px, 14.px)
                fontWeight(400)
            }
        }) { Text(reference.arabic) }

        P(attrs = {
            style {
                fontSize(14.px)
                property("font-style", "italic")
                color(Gray600)
                margin(0.px, 0.px, 8.px)
                lineHeight(1.7.em)
            }
        }) { Text("\"${reference.english}\"") }

        Div(attrs = {
            style {
                fontSize(13.px)
                fontWeight(600)
                color(QuranTextDark)
                backgroundColor(rgba(255, 255, 255, 0.7))
                borderRadius(RadiusFull.unsafeCast<CSSNumeric>())
                padding(4.px, 14.px)
                property("display", "inline-block")
                property("backdrop-filter", "blur(4px)")
            }
        }) { Text(reference.reference) }
    }
}
